import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper modal-header-wr" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    showClose: $setup.props.showClose,
    showContainer: $setup.props.showContainer,
    classes: $setup.props.classes,
    transitionName: $setup.props.transitionName,
    maxWidth: $setup.props.maxWidth,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title", {}, undefined, true)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "divider" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "description", {}, undefined, true)
        ])
      ])
    ]),
    _: 3
  }, 8, ["isOpen", "showClose", "showContainer", "classes", "transitionName", "maxWidth"]))
}